import React, { Component } from 'react'
import Hero from "../commons/Hero";
import Navbar from "../commons/Navbar";



export class Skills extends Component {


  render() {
    return (
      <div className="skills">
        <Navbar />

        
        <Hero 
          heading="Some of my skill areas"
          style={{
            backgroundColor: "rgb(0,15,107)",
            opacity: "0.90"
            }}
          image="assets/img/screenshots/lrg/pexels-photo-270404.jpg"
        />

        <div className="container">

          <div className="content">

            <div className="group">

              <h3 className="heading-3">Languages</h3>

              <ul>
                <li>Html</li>
                <li>Css</li>
                <li>PHP</li>
                <li>JavaScript</li>
              </ul>

            </div>

            <div className="group">

              <h3 className="heading-3">Frameworks</h3>

              <ul>
                <li>Laravel </li>
                <li>Node.js</li>
                <li>Bootstrap</li>
                <li>Express.js</li>
                <li>React</li>
                <li>Codeigniter </li>
              </ul>

            </div>

            <div className="group">
                <h3 className="heading-3">Databases</h3>

                <ul>
                  <li>MySQL</li>
                  <li>MongoDB</li>
                </ul>
            </div>

            <div className="group">

              <h3 className="heading-3">Other Technologies</h3>

              <ul>
                <li>WordPress</li>
                <li>Ajax</li>
                <li>Rest API</li>
                <li>Photoshop</li>
                <li>Illustrator</li>
                <li>Git / Version Control</li>
                <li>Sass</li>

              </ul>

            </div>

          </div>

        </div>
        
      </div>
    )
  }
}

export default Skills
